<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(changelog.id ? 'Edit Changelog: ' + changelog.id : 'New Changelog') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/changelogs`">
                            <i class="fa fa-code"></i> Changelogs
                        </router-link>
                    </li>
                    <template v-if="changelog.id">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/changelogs/view/${changelog.id}`">
                                Meeting on {{ changelog.released_at | moment("MM/DD/YYYY") }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Edit</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active">New Changelog</li>
                    </template>
                    <li class="ml-3">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="saveChangelog(this)" :disabled="saving">
                            <span v-if="changelog.id">Update</span>
                            <span v-else>Create</span>
                            Changelog
                        </button>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">Changelog</div>
                        <div class="card-body">
                            <div class="row form-group mb-4">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.changelog_title}">Title:</label>
                                <div class="col-md-8 col-sm-12">

                                    <b-form-input v-model="changelog.changelog_title" placeholder="Enter Changelog Title" :class="{'is-invalid': errors.changelog_title}"></b-form-input>

                                    <span v-if="errors.changelog_title" class="text-danger">
                                        <span v-for="error in errors.changelog_title">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group mb-4">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.changelog_type_id}">Type:</label>
                                <div class="col-md-8 col-sm-12">

                                    <b-form-select v-model="changelog.changelog_type_id" :options="typeOptions" :class="{'is-invalid': errors.changelog_type_id}"></b-form-select>

                                    <span v-if="errors.changelog_type_id" class="text-danger">
                                        <span v-for="error in errors.changelog_type_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div v-bind:class="{ 'row form-group mb-4': true, 'has-error': errors.released_at }" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Release Date:</label>
                                <div class="col-md-8 col-sm-12">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <b-form-datepicker v-model="released_date"></b-form-datepicker>
                                        </div>
                                        <div class="col-md-4">
                                            <b-form-timepicker v-model="released_time"></b-form-timepicker>
                                        </div>
                                    </div>

                                    <span v-if="errors.released_at" class="text-danger">
                                        <span v-for="error in errors.released_at">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header" :class="{'text-danger': errors.changelog_description}">Details</div>
                        <div class="card-body">
                            <div v-if="errors.changelog_description" class="text-danger mb-2">
                                <span v-for="error in errors.changelog_description">{{ error }}</span>
                            </div>
                            <vue-editor v-model="changelog.changelog_description"></vue-editor>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveChangelog(this)" :disabled="saving">
                <span v-if="changelog.id">Update</span>
                <span v-else>Create</span>
                Changelog
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                changelog: {},
                types: [],
                options: {
                    //format: 'MM/DD/YYYY',
                    date: ""
                },
                errors: {},
                released_date: null,
                released_time: null,
            }
        },

        computed: {
            typeOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- Select Type of Change --'},
                ];

                //Loop through and build lists
                for(var i = 0; i < this.types.length; i++)
                {
                    //Push onto options
                    options.push({value: this.types[i].id, text: this.types[i].changelog_type_name});
                }

                //Send it
                return options;
            }
        },

        watch: {
            released_date(newVal, oldVal){
                //Set it
                this.setReleasedAt();
            },

            released_time(newVal, oldVal){
                //Set it
                this.setReleasedAt();
            },
        },

        methods: {

            getChangelog: function() {
                //Get the data
                this.$http
                    .get('changelogs/edit' + (this.id ? '/' + this.id : ''))
                    .then(response => {
                        //Set all the data
                        this.changelog = response.data.changelog;
                        this.types = response.data.types;

                        //Set it
                        this.parseReleasedAt();
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveChangelog: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('changelogs/edit' + (this.id ? '/' + this.id : ''), this.changelog)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Changelog Saved');

                    //Return to main list?
                    this.$router.push('/changelogs/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            datePickerChanged ( data ) {
                // Stringify datePicked
                var dateParts = data.target.value.split("/");
                this.meeting.meeting_date = dateParts[2]+'-'+dateParts[0]+'-'+dateParts[1];
            },

            setReleasedAt(){
                //Set it
                if(!this.released_date || !this.released_time)
                {
                    return;
                }

                //Set it
                this.changelog.released_at = this.released_date + ' ' + this.released_time;
            },

            parseReleasedAt(){
                //Split it
                if(this.changelog.released_at == null)
                {
                    return;
                }

                //Parse
                var released = moment(this.changelog.released_at).tz(this.$store.state.user.timezone);

                //Set each
                this.released_date = released.format('YYYY-MM-DD');
                this.released_time = released.format('HH:mm:ss');
            },
        },

        mounted() {
            //Get the Changelog
            this.getChangelog();
        }
    }
</script>
